import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { darken } from '@material-ui/core/styles/colorManipulator';
import NavBarEnvironment from './Environment';
import NavBarUser from './User';
import Utils from '../../../../utils';
import HelpMenu from './HelpMenu';
import NavBarSearch from '../default/Search';

var styles = function styles(theme) {
  return createStyles({
    navbar: {
      paddingLeft: 0,
      paddingRight: 0,
      fontSize: theme.typography.fontSize,
      width: '100%',
      height: theme.common.Page.NavBar.style.height,
      minHeight: theme.common.Page.NavBar.style.height,
      backgroundColor: theme.common.Page.NavBar.style.backgroundColor,
      color: theme.palette.getContrastText(theme.common.Page.NavBar.style.backgroundColor),
      '& a': {
        textDecoration: 'none'
      },
      '& a:focus': {
        outlineColor: 'transparent'
      }
    },
    center: {
      textAlign: 'center'
    },
    right: {
      textAlign: 'right'
    },
    app: {
      width: 'auto',
      height: '100%',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      textAlign: 'center',
      display: 'inline-block',
      'a:hover &, a:focus &': {
        backgroundColor: '#F3F5F7'
      },
      'a:active &': {
        backgroundColor: '#E0E5EB'
      }
    },
    appGrid: {
      height: '100%'
    },
    appIconLogo: {
      color: theme.palette.getContrastText(theme.common.Page.NavBar.style.backgroundColor),
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: '50%',
      marginRight: theme.spacing(1),
      display: 'block'
    },
    appText: {
      color: theme.common.Page.NavBar.style.color,
      fontWeight: 'bold'
    },
    environmentLink: {
      color: 'inherit'
    },
    helpMenu: {
      color: theme.common.Page.NavBar.style.color,
      '&:hover': {
        backgroundColor: '#F3F5F7'
      },
      '&:active, &:focus': {
        backgroundColor: '#E0E5EB'
      }
    },
    helpMenuDot: {
      backgroundColor: '#E0E5EB',
      borderRadius: '50%',
      width: '24px',
      height: '24px',
      marginLeft: '8px',
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      '&:active, &:focus': {
        backgroundColor: '#FFF'
      }
    },
    helpMenuDotWrapper: {
      height: '50px',
      width: '40px',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        height: '60%',
        content: '""',
        left: '0',
        bottom: '0',
        borderLeft: '1px solid #000000',
        marginBottom: '10px'
      },
      '&:after': {
        position: 'absolute',
        height: '60%',
        content: '""',
        right: '0',
        bottom: '0',
        borderRight: '1px solid #000000',
        marginBottom: '10px'
      }
    }
  });
};

var DefaultLogoComponent = function DefaultLogoComponent(props) {
  return React.createElement("a", Object.assign({
    href: "/"
  }, props));
};
/**
 * @param {Props} props
 */


var MicroserviceNavBar = function MicroserviceNavBar(_ref) {
  var classes = _ref.classes,
      manifest = _ref.manifest,
      logoComponent = _ref.logoComponent,
      logoProps = _ref.logoProps,
      userInfo = _ref.userInfo,
      showSearch = _ref.showSearch,
      searchInputProps = _ref.searchInputProps; //wait for the manifest

  if (!manifest.Name) return null;
  var LogoComponent = logoComponent || DefaultLogoComponent;
  var logoChildren = React.createElement("div", {
    className: classes.app
  }, React.createElement(Grid, {
    container: true,
    justify: "center",
    alignItems: "center",
    className: classes.appGrid
  }, manifest.IconURL && React.createElement(Grid, {
    item: true
  }, React.createElement("img", {
    src: manifest.IconURL,
    alt: manifest.Name + ' icon' || 'App icon',
    className: classes.appIconLogo
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    className: classes.appText
  }, manifest.Name))));

  var logoComponentProps = _objectSpread({
    children: logoChildren
  }, logoProps);

  return React.createElement(React.Fragment, null, React.createElement(Toolbar, {
    className: classes.navbar
  }, React.createElement(Grid, {
    container: true,
    alignContent: "space-between",
    alignItems: "stretch"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement("a", {
    href: Utils.getHost() + 'home?environment=' + encodeURIComponent(userInfo.environmentName),
    className: classes.environmentLink
  }, React.createElement(NavBarEnvironment, null))), React.createElement(Grid, {
    item: true,
    xs: true,
    className: classes.center
  }, React.createElement(LogoComponent, logoComponentProps)), React.createElement(Grid, {
    item: true,
    xs: true,
    className: classes.right
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "flex-end"
  }, showSearch && React.createElement(Grid, {
    item: true
  }, React.createElement(NavBarSearch, searchInputProps)), React.createElement(Grid, {
    item: true,
    className: classes.helpMenu
  }, React.createElement("div", {
    className: classes.helpMenuDotWrapper
  }, React.createElement("div", {
    className: classes.helpMenuDot
  }, React.createElement(HelpMenu, {
    manifest: manifest,
    userInfo: userInfo
  })))), React.createElement(Grid, {
    item: true
  }, React.createElement(NavBarUser, null)))))));
};
/**
 * @typedef {object} Props
 *
 * @property {import("react").ComponentType} [logoComponent] The component used for the app logo node. Either a string to use a DOM element or a component. By default, it's an anchor which navigates to the location root.
 * @property {object} [logoProps] Properties applied to the `logoComponent`.
 * @property {boolean} [showSearch] Whether to show a search control or not
 * @property {object} [searchInputProps] Additional props to pass to the search input
 *
 * @property {object} [manifest] Injected by HoC
 * @property {object} [userInfo] Injected by HoC
 * @property {object} [classes] Injected by HoC
 * @property {object} [theme] Injected by HoC
 */


MicroserviceNavBar.defaultProps = {};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECMicroserviceNavBar'
})(MicroserviceNavBar);